import { IdmissionIDValidation } from './IdmissionIDValidation';

export function VerifyIDPage() {
  return <IdmissionIDValidation />;
}

export default VerifyIDPage;
